import React from 'react';
import { RAIL_FILTERS, filterEvents } from '../../../lib/schoolEvents';

/* All / Following / Visits / Offers, each with a live count.

   Counts are derived from the same `events` list the rail renders, never passed
   in separately — a separately-supplied count is free to drift from the content
   underneath it, and a chip that says 4 above three rows is worse than no chip. */

const LABELS = {
  all: 'All',
  following: 'Following',
  visits: 'Visits',
  offers: 'Offers',
};

export default function FilterChips({ events, active, onChange }) {
  return (
    <div className="rail-chips" role="group" aria-label="Filter activity">
      {RAIL_FILTERS.map((f) => {
        const count = filterEvents(events, f).length;
        const isActive = f === active;
        return (
          <button
            key={f}
            type="button"
            className={`rail-chip${isActive ? ' rail-chip--active' : ''}`}
            aria-pressed={isActive}
            onClick={() => onChange(f)}
            data-testid={`rail_chip_${f}`}
          >
            {LABELS[f]}
            <span className="rail-chip__count">{count}</span>
          </button>
        );
      })}
    </div>
  );
}
